import { useEffect, useState, useCallback } from 'react';
import { usersApi } from '../../api/users';

export const useQueryMe = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<{ me: any } | undefined>();
  const [refetchTrigger, setRefetchTrigger] = useState(0);

  const refetch = useCallback(() => {
    setRefetchTrigger((prev) => prev + 1);
  }, []);

  useEffect(() => {
    setLoading(true);
    usersApi
      .me()
      .then((userRes) => {
        const u = userRes.data;
        setData({
          me: {
            active: u.active,
            email: u.email,
            fullName: u.full_name,
            refId: u.ref_id,
            role: u.role,
            speciality: u.speciality,
            forceResetPassword: u.force_reset_password,
            current: u.current
              ? {
                  permissions: u.current.permissions,
                  organization: u.current.organization
                    ? {
                        name: u.current.organization.name,
                        refId: u.current.organization.ref_id,
                        availableData: u.current.organization.available_data
                          ? {
                              from: u.current.organization.available_data.from_date,
                              to: u.current.organization.available_data.to_date,
                            }
                          : undefined,
                      }
                    : null,
                }
              : null,
          },
        });
      })
      .catch(() => setData(undefined))
      .finally(() => setLoading(false));
  }, [refetchTrigger]);

  return { loading, data, refetch };
};
